module.exports = __webpack_public_path__ + "img/turn_logo.31d84d29.png";